import React, { useMemo, useCallback } from "react"
import {
  Avatar,
  Box,
  Card,
  CardMedia,
  Divider,
  Typography,
  useTheme,
} from "@mui/material"
import { deepmerge } from "@mui/utils"
import get from "lodash/get"
import clsx from "clsx"

import { getFeatureDetail } from "utils/feature"
import { useTranslation } from "providers/i18n"

import { CustomIcon } from "components/icons"
import { ShopIcon } from "../../icons"

export const DirectoryOccupantCard = ({
  data,
  onClick,
  sx,
  endAdornment,
  ...props
}) => {
  const { t } = useTranslation()
  const categoryIcon = useMemo(
    () => get(data, "properties.local_categories[0].properties.icon_path"),
    [data]
  )
  const {
    name,
    logo,
    level,
    venueLogo,
    venueName,
    venueRef,
    isHighlight,
    extendedLogo,
    coverImage,
  } = useMemo(() => getFeatureDetail(data), [data])
  const handleClick = useCallback(() => onClick(data), [onClick, data])

  const theme = useTheme()
  const { styleOverrides = {} } =
    theme.components?.[`DirectoryOccupantCard`] || {}
  const {
    root,
    occupantLogo,
    cardContent,
    levelContainer,
    venueTextContainer,
    divider,
    venueLogo: venueLogoStyle,
    titleText,
    titleContainer,
    detailWrapper,
    infoContainer,
    primaryCoverAvatar,
    secondaryCoverAvatar,
  } = styleOverrides
  const primaryCoverImage = isHighlight ? extendedLogo : logo
  const secondaryCoverImage = coverImage || extendedLogo
  return (
    <Card sx={deepmerge(root, sx)} onClick={handleClick} {...props}>
      <Box sx={occupantLogo}>
        <Avatar
          sx={primaryCoverAvatar}
          className="DirectoryOccupantCard-primaryCoverAvatar"
          src={primaryCoverImage}
        >
          {!primaryCoverImage &&
            (categoryIcon ? <CustomIcon path={categoryIcon} /> : <ShopIcon />)}
        </Avatar>
        <Avatar
          sx={secondaryCoverAvatar}
          className="DirectoryOccupantCard-secondaryCoverAvatar"
          src={secondaryCoverImage}
        >
          {!secondaryCoverImage &&
            (categoryIcon ? <CustomIcon path={categoryIcon} /> : <ShopIcon />)}
        </Avatar>
      </Box>
      <Box sx={cardContent} className="DirectoryOccupantCard-cardContent">
        <Box sx={titleContainer}>
          <Typography sx={titleText}>{t(name)}</Typography>
        </Box>
        <Box sx={detailWrapper}>
          <Divider sx={divider} />
          <Box sx={infoContainer}>
            <Box
              sx={levelContainer}
              className={clsx("DirectoryOccupantCard-levelContainer", venueRef)}
            >
              <Typography variant="h6">{t(level)}</Typography>
            </Box>
            <Box sx={venueTextContainer}>
              <Typography variant="h6">{t(venueName)}</Typography>
            </Box>
            <CardMedia component="img" image={venueLogo} sx={venueLogoStyle} />
          </Box>
        </Box>
      </Box>
    </Card>
  )
}
